import { DARK_MUTED } from '@lyon/utils/theme/colors/darkmuted';
import { BlockOverrides } from 'baseui/block';

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      paddingTop: '16px',
      paddingBottom: '16px',
      width: '100%',
      backgroundColor: DARK_MUTED.darkmuted600,
      filter: 'contrast(1.015)',
    },
  },
};
